<div class="wrapper">
  <img src="../../../assets/main/loaderImage.gif" alt="Cheapticket" class="img-fluid">
  <div class="content">
    <h3 class="title">Processing...</h3>
    <p>Please Wait for payment confirmation</p>
  </div>
</div>
